<template>
    <section class="lander text-center" style="background-image: url('../Background_grey.jpg');">
        <div class="container" v-bind:class="{ 'mobile': this.$store.getters.isMobile }">
            <div class="lander__logo" v-if="!this.$store.getters.isMobile"><img src="/logo@2x.png" alt="Cerner" class="logo"></div>
            <MobileMenu v-if="this.$store.getters.isMobile" />

            <div class="lander__body" v-bind:class="{ 'mobile': this.$store.getters.isMobile }">
                <div class="card text-center">
                    <div class="card__body">
                        <h1 class="text-large-heading">Explore Client Value</h1>

                        <p class="text-emphasize">Discover client success stories about organizations just like yours. Select the topics you’re most interested in, and relevant content will be displayed on a customized dashboard. Share your dashboard with yourself or a friend, and continue exploring on your personal device.</p>

                        <a @click="reset" class="button">Begin Experience</a>
                    </div>
                </div>
            </div>
            <div class="lander__footer"><router-link to="/portal" class="text-light-alt text-no-decoration text-weight-500">Skip ahead to regular dashboard</router-link></div>
        </div>
    </section>
</template>

<script>
    import router from '../router.js';
    import EventBus from '../eventbus.js';
    import MobileMenu from './../components/MobileMenu';

    export default {
        data : function() {
            return {
                isMobile: this.$store.getters.isMobile
            }
        },
        mounted() {
            if ( !this.$store.getters.eventLoggedLanding ) {
                EventBus.$emit('gtag', {
                    action: 'view',
                    details: {
                        'event_category': 'general',
                        'event_label': 'Landing Page', 
                        'value': 1
                    },
                    name: 'eventLoggedLanding'
                });

                this.$store.commit('updateEventLogged', 'landing');
            }
        },
        methods: {
            reset() {
                sessionStorage.clear();
                window.location.href = "/custom-dashboard";
            },
            resetVuex() {
                // code to reset vuex
                let initialState = {
                    "token": null,
                    "user": {}
                }

                const state = Vue.util.extend({}, initialState)

                const mutations = {
                    RESET_STATE(state, payload) {
                        for (let f in state) {
                            Vue.set(state, f, initialState[f])
                        }
                    }
                }
            }
        },
        components: {
            MobileMenu
        }
    }
</script>

<style scoped>
    .container.mobile {
        padding-left: 1em;
        padding-right: 1em;
    }

    .container.mobile .text-large-heading {
        width: 100%;
    }

    .lander__body {
        display: flex;
        align-items: center;
        justify-content: center;
        min-height: 85vh;
    }

    .lander__body.mobile {
        width: 100%;
        max-width: 500px;
    }

    a.button {
        cursor: pointer;
    }

    @media (max-width: 400px) {
        .lander__body.mobile .card {
            min-height: 55vh;
            height: auto;
            margin-top: 5em;
        }
        .lander__body.mobile .card__body {
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            padding: 2em 1em;
        }

        .lander__body.mobile .card__body p.text-emphasize {
            margin: 2em 0;
        }

        .lander__footer {
            margin-top: 2em;
        }
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/views/LandingScreen.vue